//@ts-check
import React from 'react';
import { HotKeys } from 'react-hotkeys';
var KEY_MAP = {
  SUBMIT: 'ctrl+s'
};

var FormKeys = function FormKeys(_ref) {
  var children = _ref.children,
      onSubmit = _ref.onSubmit;
  var keyHandlers = {
    SUBMIT: function SUBMIT(e) {
      if (onSubmit) {
        onSubmit();
        e.preventDefault();
      }

      ;
      e.stopPropagation();
    }
  };
  return React.createElement(HotKeys, {
    keyMap: KEY_MAP,
    handlers: keyHandlers // filter={() => true}
    ,
    style: {
      outline: 'none'
    }
  }, children);
};

export default FormKeys;